import { CircleDollarSign, Package, Repeat, Workflow, type LucideIcon } from 'lucide-react';
import type { GetOrganizationDetailTabIconParams, OrganizationDetailTab } from '../types';

const ORGANIZATION_DETAIL_TAB_ICONS: Record<OrganizationDetailTab, LucideIcon> = {
    services: Package,
    subscription: Repeat,
    costs: CircleDollarSign,
    workflows: Workflow,
};

const getOrganizationDetailTabIcon = ({ tab }: GetOrganizationDetailTabIconParams): LucideIcon =>
    ORGANIZATION_DETAIL_TAB_ICONS[tab];

export default getOrganizationDetailTabIcon;
